import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';

import { AdminLayoutComponent } from '../theme/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from '../theme/auth-layout/auth-layout.component';
import {AuthGuard} from '../auth-guard/auth.guard';
import { FccpLayout } from './sessions/FCCP/fccp-layout';
import { Fccphome } from './sessions/FCCP/home/fccp-home';
import { FccpLogin } from './sessions/FCCP/login/fccp-login';
import { FccpRegisteration } from './sessions/FCCP/registeration/fccp-registeration';
import { FccpVerification } from './sessions/FCCP/verification/fccp-verification';


const routes: Routes = [
  {
    path: 'home',
    component: AdminLayoutComponent,
    canActivate:[AuthGuard],
  },
  { path: '', redirectTo: 'fccp', pathMatch: 'full' },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      
    ],
  },
  {
    path: 'fccp',
    component: FccpLayout,
    children: [
      { path: '', redirectTo: 'fccplogin', pathMatch: 'full' },
      {

        path: 'fccplogin',
        component: FccpLogin
       
      },
      {
        path: 'home',
        component: Fccphome,
        canActivate:[AuthGuard],
      },
      {
        path: 'fccpregisteration',
        component: FccpRegisteration
      },
      {
        path: 'fccpverification',
        component: FccpVerification
      },
      
    ]
  },
  { path: '**', redirectTo: 'dashboard' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash
    }),
  ],
  declarations: [ ],
  exports: [RouterModule],
})
export class RoutesRoutingModule {}
